import { render, staticRenderFns } from "./QuickReplyOptions.vue?vue&type=template&id=99efd102"
import script from "./QuickReplyOptions.vue?vue&type=script&lang=js"
export * from "./QuickReplyOptions.vue?vue&type=script&lang=js"
import style0 from "./QuickReplyOptions.vue?vue&type=style&index=0&id=99efd102&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports